module.exports = __webpack_public_path__ + "static/unnamed-1--05ffb61e92c179cb70ac11b0c9865e19.png";